/**
 * Deletes all properties from the provided object
 * @param obj The object to delete properties from
 */
export const deleteObjectProperties = (obj: any): void => {
  if (typeof obj === "object" && !Array.isArray(obj) && obj !== null) {
    for (const prop of Object.getOwnPropertyNames(obj)) {
      delete obj[prop];
    }
  }
};

/**
 * Determines if the provided object is a Promise
 * @param obj The object to check
 * @returns True if the object is a Promise, otherwise false
 */
export const isPromise = <T = any>(obj: any): obj is Promise<T> => {
  return !isNullOrUndefined(obj?.then) && typeof obj.then === "function";
};

/**
 * checks if the object is null or undefined
 * @param obj The object to check
 * @returns True if the object is null or undefined, otherwise false
 */
export const isNullOrUndefined = (obj: unknown): boolean => obj === null || obj === undefined;

/**
 * Checks if any of the provided objects are null or undefined
 * @param objs The objects to check
 * @returns True if any of the objects are null or undefined, otherwise false
 */
export const anyAreNullOrUndefined = (objs: unknown[]): boolean =>
  objs === null || objs === undefined || (Array.isArray(objs) && objs.some((obj) => isNullOrUndefined(obj)));

/**
 * checks if the object has value (not null or undefined)
 * @param obj The object to check
 * @returns True if the object has value, otherwise false
 */
export const hasValue = <T = unknown>(obj: unknown): obj is T => !isNullOrUndefined(obj);

/**
 * Checks if the object has keys
 * @param obj The object to check
 * @returns True if the object has keys, otherwise false
 */
export const objectHasKeys = (obj?: unknown): boolean => {
  return (
    !isNullOrUndefined(obj) && typeof obj === "object" && !Array.isArray(obj) && Object.keys(obj!).length > 0
  );
};
